export var ReferralStatus;
(function (ReferralStatus) {
    /** 피추천인이 추천코드를 사용해 연결됨 (아직 보상 전) */
    ReferralStatus["PENDING"] = "PENDING";
    /** 피추천인 첫 예약 반납완료 → 추천인 보상 지급됨 */
    ReferralStatus["REWARDED"] = "REWARDED";
    /** 피추천인 첫 예약이 취소되는 등으로 무효화됨 */
    ReferralStatus["CANCELED"] = "CANCELED";
})(ReferralStatus || (ReferralStatus = {}));
